let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lQN2i")).then(() => parcelRequire('juvgQ'));